import React from 'react';
import type { KpiTrendPoint } from '@/services/salesDashboard.service';

export const Sparkline: React.FC<{ points: KpiTrendPoint[]; width?: number; height?: number }> = ({
  points,
  width = 120,
  height = 24,
}) => {
  if (points.length < 2) return null;
  const values = points.map((p) => p.value);
  const min = Math.min(...values);
  const max = Math.max(...values);
  const range = max - min || 1;
  const step = width / (values.length - 1);
  const coords = values
    .map((v, i) => {
      const x = i * step;
      const y = height - ((v - min) / range) * (height - 2) - 1;
      return `${x},${y}`;
    })
    .join(' ');
  return (
    <svg width={width} height={height} style={{ display: 'block' }}>
      <polyline fill="none" stroke="#145A54" strokeWidth="1.5" points={coords} />
    </svg>
  );
};
